import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReportsCards from "./RegisterDocuments/ReportsCards";
import ReportsBreadCrumbs from "./ReportsBreadCrumbs";
import { TestTemplateRegistry } from "./TestTemplateRegistry/TestTemplateRegistry";
import TestRegistryProvider from "./TestTemplateRegistry/store/testRegistryProvider";
import { AuditReport } from "./AuditReport";
import { CalendarOwdReport } from "./CalendarOwdReport";
import { EmployeesReport } from "./EmployeesReport";
import GeneralReport from "./GeneralReport";
import { NotificationsReport } from "./NotificationsReport";
import { ReportDocuments } from "./ReportDocuments";
import WorkPlaceReport from "./WorkPlaceReport";

export default function ReportsPage() {
  const { reportID } = useParams();
  const path =
    reportID === "1"
      ? ["Реестр документов"]
      : reportID === "2"
      ? ["Календарь OWD"]
      : reportID === "3"
      ? ["Отчет по ознакомлению"]
      : reportID === "4"
      ? ["Реестр уведомлений"]
      : reportID === "5"
      ? ["Отчеты по сотрудникам"]
      : reportID === "6"
      ? ["Общий отчет"]
      : reportID === "7"
      ? ["Реестр шаблонов тестов"]
      : reportID === "8"
      ? ["Отчет ознакомлений по рабочим местам"]
      : [];

  const [crumbs, setCrumbs] = useState<string[]>(path);

  const addSetCrumbs = (newCrumb: string) => {
    setCrumbs(() => [newCrumb]);
  };

  useEffect(() => {
    if (!reportID) {
      setCrumbs([]);
    }
  }, [reportID]);

  return (
    <>
      {reportID ? (
        <>
          {reportID === "1" && <ReportDocuments />}
          {reportID === "2" && <CalendarOwdReport />}
          {reportID === "3" && <AuditReport />}
          {reportID === "4" && <NotificationsReport />}
          {reportID === "5" && <EmployeesReport />}
          {reportID === "6" && <GeneralReport />}
          {reportID === "7" && (
            <div>
              <TestRegistryProvider
                children={
                  <div>
                    <TestTemplateRegistry crumbs={crumbs} />
                  </div>
                }
              />
            </div>
          )}
          {reportID === "8" && <WorkPlaceReport />}
        </>
      ) : (
        <>
          <ReportsBreadCrumbs reportsCrumbs={crumbs} />
          <ReportsCards addSetCrumbs={addSetCrumbs} />
        </>
      )}
    </>
  );
}
